import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/educacao/receitas/listar/form_edit'
import Head from '../../../../../components/head'


function EditarReceitaEducacaoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Receita da Secretaria Municipal de Educação" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarReceitaEducacaoScreen;